import { useMemo, useState, useEffect } from "react";
import posthog from "posthog-js";
import { CHRISTMAS_THEME } from "@/recourses/constants";

export default function useFeatureFlags() {
  const [posthogReady, setPosthogReady] = useState(false);

  useEffect(() => {
    posthog.onFeatureFlags(() => setPosthogReady(true));
  }, []);

  return useMemo(
    () => ({
      isChristmasTheme: posthog.isFeatureEnabled("christmasTheme") ?? CHRISTMAS_THEME,
      smsOtpEnabled: posthog.isFeatureEnabled("smsOtpEnabled") ?? false,
    }),
    [posthogReady]
  );
}
